import { useCallback, useSyncExternalStore } from "react";

/**
 * Sphere-mode activation lives outside React tree state so it survives route
 * changes: opening an article hides the overlay but keeps the mode armed until
 * the user explicitly exits.
 */
const KEY = "byteline:sphere-mode";

let active = (() => {
  try {
    return sessionStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
})();

const listeners = new Set<() => void>();

const subscribe = (fn: () => void) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

const getSnapshot = () => active;

function set(next: boolean) {
  if (active === next) return;
  active = next;
  try {
    if (next) sessionStorage.setItem(KEY, "1");
    else sessionStorage.removeItem(KEY);
  } catch {
    /* storage unavailable, in-memory only */
  }
  listeners.forEach((fn) => fn());
}

export function useSphereMode() {
  const isActive = useSyncExternalStore(subscribe, getSnapshot, () => false);
  const open = useCallback(() => set(true), []);
  const close = useCallback(() => set(false), []);
  return { isActive, open, close };
}
